import http from "@/common/http-common";

class InstanceService {
  async checkExist(instance_name) {
    return await http(instance_name).get("/api/v1/countries.json").then(function(resp) {
      if (resp.data) {
        return true
      } else {
        return false
      }
    }).catch(function(error) {
      console.log("Inside InstanceService, error ==> ", error);
      return false
    });
  }
}

export default new InstanceService();